import {
  Tabs,
  Row,
  Col
} from 'antd';
import {
  WeaErrorPage,
  WeaTools,
  WeaTableEdit,
  WeaSearchGroup,
  WeaRightMenu,
  WeaFormItem,
  WeaTab,
  WeaNewScroll
} from 'ecCom'
import isEmpty from 'lodash/isEmpty'
import * as mobx from 'mobx';
import {
  inject,
  observer
} from 'mobx-react';
import SystemCard from './SystemCard';
import PortraitSetting from './PortraitSetting';
import {
  routerShape
} from 'react-router';
import '../../style/card.less';
const toJS = mobx.toJS;
import {
  WeaPopoverHrm
} from 'ecCom';
import TopButton from '../../coms/topButton';
import {i18n} from '../../public/i18n';

@inject('hrmCard')
@observer
class Main extends React.Component {
  static contextTypes = {
    router: routerShape,
  }
  constructor(props) {
    super(props);
  }
  getkey(path) {
    return path.match(/hrm\/card\/\w+/)[0].split('/')[2] || '';
  }
  componentWillReceiveProps(nextProps) {
    const key = this.getkey(nextProps.location.pathname);
    if (this.props.location.key !== nextProps.location.key && key == 'cardInfo') {
      const {
        hrmCard
      } = this.props;
      hrmCard.init(key);
    }
  }
  componentDidMount() {
    const {
      hrmCard
    } = this.props;
    const {
      pathname
    } = this.props.location;
    const key = this.getkey(pathname);
    const hrmId = this.props.params.hrmId || '';
    //const hrmId = pathname.match(/cardInfo\/\w+/)[0].split('/')[1]
    hrmCard.init(key);
    hrmCard.verifyIsAdmin({
      id: hrmId
    });
    hrmCard.getData({
      id: hrmId
    });
  }

  getTabChildren() {
    const {
      hrmCard,
      children
    } = this.props;
    let {
      tabInfo,
      tabKey
    } = hrmCard;
    let isIframe = false;
    let ifame;
    let innerPage = false;
    if (window.location.href.indexOf("/spa/hrm/index_mobx.html") == -1) {
      innerPage = true;
    }
    tabInfo = toJS(tabInfo);
    tabInfo && tabInfo.forEach((t) => {
      if (tabKey === t.key) {
        if (t.isIframe) {
          isIframe = true;
          ifame = <iframe className="card-iframe"  style={{height:window.innerHeight-175}} src={t.url}></iframe>
        }
      }
    })
    return (
      <WeaNewScroll height={innerPage?window.innerHeight-160:window.innerHeight-110}>
      {isIframe ? ifame : children}
      </WeaNewScroll> 
    );
  }
  render() {
    const {
      hrmCard
    } = this.props;
    let {
      verified,
      isAdmin,
      info,
      tabInfo,
      tabKey,
      showPortraitSetting,
      uploadPortrailAuth
    } = hrmCard;
    info = toJS(info);
    const portraitDefalut = '/messager/images/icon_m_wev8.jpg';
    if (window.location.href.indexOf("/spa/hrm/index_mobx.html") > -1) {
      if (info) {
        let lastname = info.lastname || '';
        document.title = i18n.label.resourceCard() + '-' + lastname;
      }
    }
    if (verified && isAdmin) {
      return (
        <SystemCard {...this.props}/>
      )
    }
    if (verified && !isAdmin) {
      return (
        <WeaPopoverHrm>
        <div className='hrm-my-card' style={{height:"100%",background: '#ffff'}}>
          <div className="hrm-my-card-top-wapper">
            {
              !isEmpty(info) && <Row className={"hrm-my-card-top"}>
                <Col span="14" className='hrm-my-card-top-title' style={{paddingLeft:14,paddingTop:7}}>
                  {
                    info.shortname != null && info.shortname.trim().length > 0 ?
                    <div className='hrm-my-card-top-title-img hrm-my-card-top-title-shortname' onClick={showPortraitSetting}>{info.shortname}</div>
                    :
                    <span style={{verticalAlign:'middle',paddingLeft:10,paddingRight:14}}>
                      <img className='hrm-my-card-top-title-img' src={info.messagerurl || portraitDefalut} alt="" onClick={showPortraitSetting}/>
                    </span>
                  }
                  <span style={{display:'inline-block',verticalAlign:'30%'}} className='hrm-my-card-top-title-info'>
                    <div style={{fontSize:14,paddingBottom:6}}>
                      <span style={{paddingRight:5}}>{info.lastname} {info.workcode ? `(${info.workcode})` : ''}</span>
                      <span className={info.sex.value=='1'?'icon-coms-women femaleColor':'icon-coms-men maleColor'} title={info.sex.name}></span>
                    </div>
                    <div className='orgInfo'
                      dangerouslySetInnerHTML={{__html:info.orginfo}} />
                  </span>
                </Col>
              </Row>
            }
            <TopButton
              buttons={hrmCard.topButtons && hrmCard.topButtons()}
              buttonSpace={10}
              showDropIcon={hrmCard.topShowDropIcon}
              dropMenuDatas={hrmCard.topRightMenus && hrmCard.topRightMenus()}
            />
          </div>
          <WeaTab
            type='editable-inline'
            keyParam='key'
            datas={toJS(tabInfo)}
            selectedKey={tabKey}
            onChange={ v => {
              this.tabsOnChange(v);
            }}
          />
          {this.getTabChildren()}
        </div>
        {uploadPortrailAuth && <PortraitSetting store={hrmCard}/>}
        </WeaPopoverHrm>
      )
    }
    return (<div></div>)
  }

  tabsOnChange(key) {
    const {
      hrmCard
    } = this.props;
    
    hrmCard.setTopButtons(null);
    hrmCard.setTopRightMenus(null);
    hrmCard.setTopShowDropIcon(false);
    let {
      tabInfo
    } = hrmCard;
    hrmCard.changeTab(key);
    tabInfo = toJS(tabInfo);
    tabInfo && tabInfo.forEach((t) => {
      if (t.key === key && !t.isIframe) {
        this.context.router.push({
          pathname: t.pathname,
          query: {
            fromcard: true
          }
        })
      }
    })
  }
}
export default Main;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/card/index.js